import { Form } from 'factorial-form'

class AllowanceIncidence extends Form {
  constructor(values: {}) {
    super(values, {
      effective_on: 'string',
      days_in_cents: 'cents',
      employee_id: 'number',
      day_type: 'string',
      sign: 'string',
      timeoff_allowance_id: 'number',
      description: 'string',
      target_balance: 'string',
      _skip_notifications: 'boolean',
    })
  }
  get validateInput(): boolean {
    return (
      !this.get('days_in_cents').value ||
      !this.get('effective_on').value ||
      !this.get('timeoff_allowance_id').value
    )
  }
}

export default AllowanceIncidence
